import WeddingPhoto from './WeddingPhoto';
export default WeddingPhoto;

